// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandableSection__container--G-T","icon":"ExpandableSection__icon--3-G","title":"ExpandableSection__title--2Y6","btn":"ExpandableSection__btn--3gD"};